@if (clientBatchId$ | async; as clientBatchId) {
  <span class="client-batch-id-label">Client batch ID</span>
  <span class="client-batch-id"> {{ clientBatchId }} </span>
}
